import { MenuOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type MenuItemSpecsFragment } from '../../../api/fragments/MenuItemSpecs';
import ProfileCard from '../../../components/ProfileCard';
import SignOutButton from '../../../components/SignOutButton';
import { useThemeComponents } from '../../../themes';
import CIMenuItems from './CIMenuItems';
import DealerSelector from './DealerSelector';

const StyledDrawer = styled(Drawer)`
    & .ant-drawer-content-wrapper {
        width: 287px !important;
    }

    .ant-drawer-header-title {
        justify-content: end;
    }
    .ant-drawer-body {
        padding: 0px;
    }
    .ant-drawer-close {
        margin-top: 16px;
        margin-right: 0px;
    }
`;

const ProfileCardContainer = styled.div`
    padding: 16px 0px 24px;
`;

type ProfileHeaderProps = {
    collapsed: boolean;
    onClose: () => void;
    onMenuItemClicked: (path: string) => void;
    onAvatarClicked: () => void;
    menuItems: MenuItemSpecsFragment[];
};

const CIMenu = ({ collapsed, onClose, onMenuItemClicked, onAvatarClicked, menuItems }: ProfileHeaderProps) => {
    const { t } = useTranslation(['core']);
    const direction = t('core:orientation');
    const { notification } = useThemeComponents();

    return (
        <StyledDrawer
            closeIcon={<MenuOutlined style={{ color: 'var(--ant-primary-color)' }} />}
            onClose={onClose}
            open={!collapsed}
            placement={direction === 'rtl' ? 'right' : 'left'}
            title={null}
        >
            <ProfileCardContainer>
                <ProfileCard
                    actions={[<SignOutButton themedNotification={notification} />]}
                    extra={<DealerSelector />}
                    onAvatarClicked={onAvatarClicked}
                />
            </ProfileCardContainer>
            <CIMenuItems menuItems={menuItems} onMenuItemClicked={onMenuItemClicked} />
        </StyledDrawer>
    );
};

export default CIMenu;
